import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-balace-wallet',
  templateUrl: './add-balace-wallet.component.html',
  styleUrls: ['./add-balace-wallet.component.scss']
})
export class AddBalanceWalletComponent implements OnInit {
  balanceForm!: FormGroup;

  rangeArray = Array.from({ length: 100 }, (_, i) => i);
  selectedAmount: number = 0;
  progressBarWidth: number = 0;
  indicatorPosition: number = 0;
  suggestedAmount: number = 3100;
  @ViewChild('slider') slider!: ElementRef<HTMLInputElement>;

  constructor(private fb: FormBuilder, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.balanceForm = this.fb.group({
      amount: [null, Validators.required],
      rangeIndex: [0],
    });

    this.balanceForm.get('rangeIndex')?.valueChanges.subscribe((index) => {
      this.updateSlider(index);
    });
  }

  onSliderInput(event: Event): void {
    const index = +(event.target as HTMLInputElement).value;
    this.balanceForm.get('rangeIndex')?.setValue(index, { emitEvent: true });
  }

  updateSlider(index: number): void {
    this.selectedAmount = this.rangeArray[index];

    // Update visual position
    const sliderEl = this.slider.nativeElement;
    const sliderWidth = sliderEl.offsetWidth;
    const thumbWidth = 24; // Match your thumb width in CSS
    const maxLeft = sliderWidth - thumbWidth;
    const percent = index / (this.rangeArray.length - 1);

    // Ensure position stays within bounds
    this.indicatorPosition = Math.min(maxLeft, Math.max(0, percent * sliderWidth));
    this.progressBarWidth = percent * sliderWidth;
  }
  copySuggestedAmount() {
    const amount = this.getSuggestedAmount();
    this.copyToClipboard(amount.toString()).then(() => {
      // Show success feedback
      this.showCopyFeedback();
    }).catch(err => {
      console.error('Failed to copy amount:', err);
      // Fallback - directly set the value if clipboard fails
      this.balanceForm.get('amount')?.setValue(amount);
    });
  }

  applySuggestedAmount() {
    // Convert to number if needed
    const amount = Number(this.suggestedAmount);

    // Update the form control
    this.balanceForm.patchValue({
      amount: amount
    });

    // Find closest index in rangeArray
    const index = this.rangeArray.findIndex(val => val >= amount);
    if (index !== -1) {
      this.balanceForm.patchValue({
        rangeIndex: index
      });
      // Manually trigger the update
      this.updateSlider(index);
    }

    // Force change detection (sometimes needed)
    this.cdr.detectChanges();

    console.log('Form value after apply:', this.balanceForm.value);
  }

  private showApplyFeedback() {
    // You can add visual feedback here if needed
    console.log(`Applied amount: $${this.suggestedAmount}`);
  }

  private copyToClipboard(text: string): Promise<void> {
    // Modern clipboard API
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(text);
    }

    // Fallback for older browsers
    return new Promise((resolve, reject) => {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.position = 'fixed';  // Prevent scrolling to bottom
        document.body.appendChild(textarea);
        textarea.select();

        const success = document.execCommand('copy');
        document.body.removeChild(textarea);

        success ? resolve() : reject(new Error('Copy command failed'));
      } catch (err) {
        reject(err);
      }
    });
  }

  private showCopyFeedback() {
    // Change icon temporarily
    const icon = document.querySelector('.pi-clone');
    if (icon) {
      icon.classList.replace('pi-clone', 'pi-check');

      setTimeout(() => {
        icon.classList.replace('pi-check', 'pi-clone');
      }, 2000);
    }
  }

  getSuggestedAmount(): number {
    // Extract from text or use default
    return 3100; // Or your logic to get the amount
  }

  onSubmit(): void {
    const amountValue = this.balanceForm.get('amount')?.value;
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const phoneNumber = user.phoneNumber;
    const name = user.firstName || 'User';
    if (!amountValue || amountValue <= 0) {
      console.warn('Invalid amount.');
      return;
    }
  
    const options: any = {
      key: 'rzp_test_aLY35P49OeTQNl',
      amount: amountValue * 100,
      currency: 'INR',
      name: name, 
      description: 'Wallet Top-Up',
      handler: (response: any) => {
        console.log('Payment successful:', response);
      },
      prefill: {
        name: name,
        contact: phoneNumber
      },
      theme: {
        color: '#F37254'
      }
    };
    
  
    const rzp = new (window as any).Razorpay(options);
    rzp.open();
  
    // Optional: handle payment failure
    rzp.on('payment.failed', function (response: any) {
      console.error('Payment failed:', response.error);
    });
  }
  
}